import Accordion from '@service-victoria/component-library/components/Accordion';
import { Button } from '@service-victoria/component-library/components/Button';
import Page from '@service-victoria/component-library/components/Page';
import Tabs, { TabItem } from '@service-victoria/component-library/components/Tabs';
import Text from '@service-victoria/component-library/components/Text';
import VicStateGov from 'assets/VicStateGov.svg';
import React from 'react';
import { useHistory } from 'react-router';

import ContentSlot from 'components/ContentSlot';
import l from 'content';
import useWindowSize from 'hooks/useWindowSize';
import { breadCrumbs, Routes } from 'utils/constants';

import {
  Wrapper,
  Header,
  Description,
  TimerBox,
  Timer,
  Icon,
  TextHead,
  DoubleLine,
  Line,
  Main,
  Footer,
  VicLogo,
  Aside,
  SignpostWrapper
} from './styled';

const items: TabItem[] = [
  {
    id: 'before-you-start',
    title: l('home-tab-1'),
    component: <ContentSlot slot='homepage' />
  },
  {
    id: 'what-you-need',
    title: l('home-tab-2'),
    component: <ContentSlot slot='whatYouNeed' />
  },
  {
    id: 'faq',
    title: l('home-tab-3'),
    component: <ContentSlot slot='faq' />
  }
];

export const Home: React.FC<Record<string, never>> = () => {
  const history = useHistory();
  const windowSize = useWindowSize();

  const isSignposted = true; //now < +new Date(Config.TransactionStartTs);

  return (
    <Page
      title={l('page-title')}
      showFooter
      breadCrumbs={breadCrumbs}
      headerProps={{
        fetchItemsFromAPI: true,
        showSideNav: true
      }}>
      <Wrapper>
        {isSignposted ? (
          <Main>
            <SignpostWrapper>
              <Text.Heading.H1>
                The construction industry no longer need to complete a COVIDSafe construction
                declaration.
              </Text.Heading.H1>
              <Text.Body>
                For more info about coronavirus (COVID-19) Victoria visit{' '}
                <Text.Link href='https://www.betterhealth.vic.gov.au/coronavirus-covid-19-victoria'>
                  betterhealth.vic.gov.au
                </Text.Link>
                .
              </Text.Body>
            </SignpostWrapper>
          </Main>
        ) : (
          <>
            <Header>
              <Description>{l('home-banner')}</Description>
              <Line />
              <TimerBox>
                <Timer>
                  <Icon />
                  <TextHead>
                    {l('home-clock-preamble')}
                    <span>{l('home-time-to-complete')}</span>
                  </TextHead>
                </Timer>
              </TimerBox>
            </Header>
            <DoubleLine />
            <Main>
              {windowSize === 'mobile' ? <Accordion items={items} /> : <Tabs items={items} />}
            </Main>
          </>
        )}
        <Aside>
          <Footer>
            <VicLogo>
              A program of
              <img src={VicStateGov} alt='Victoria State Government' width='100' />
            </VicLogo>
            {isSignposted ? (
              <Button
                type='button'
                onClick={() => {
                  window.location.href = 'https://www.service.vic.gov.au';
                }}>
                Home
              </Button>
            ) : (
              <Button type='button' onClick={() => history.push(Routes.Transaction)}>
                Get started
              </Button>
            )}
          </Footer>
        </Aside>
      </Wrapper>
    </Page>
  );
};
export default Home;
